import { emptyArray } from '../../../../../../../../utils/arrayUtils';

export { createUpdatedListFilters } from '../ActiveFiltersSummary/helpers';

export function syncExpirationStatus(filterType, statuses) {
  return statuses.find((s) => s.value === filterType) || statuses[0];
}

export function syncTagSelection(tagValues) {
  if (emptyArray(tagValues)) return [];
  return tagValues.map((t) => ({ create: t, value: t }));
}

export function syncLocationSelection(stateValues) {
  if (emptyArray(stateValues)) return [];
  return stateValues.map((l) => ({
    code: l.code || l.id,
    name: l.name || l.value || l.code || l.id,
    id: l.id || l.code,
    value: l.value || l.name || l.code || l.id,
  }));
}

export function buildTagFilterValue(val) {
  if (emptyArray(val) || val.some((i) => i.value === 'all')) return null;
  return { type: 'ANY_OF_THOSE', value: val.map((t) => t.create) };
}

export function buildLocationFilterValue(val) {
  if (emptyArray(val)) return null;
  return {
    type: 'ANY_OF_THOSE',
    value: val.map((l) => ({
      id: l.code,
      code: l.code,
      value: l.name || l.code,
      name: l.name || l.code,
    })),
  };
}

export function buildSetAsideFilterValue(val) {
  if (emptyArray(val)) return null;
  return {
    type: 'ANY_OF_THOSE',
    value: val.map((sa) => ({
      id: sa.id || sa.code,
      code: sa.code || sa.id,
      value: sa.value || sa.code || sa.id,
    })),
  };
}

export function buildNaicsFilterValue(val) {
  if (emptyArray(val)) return null;
  return { type: 'ANY_OF_THOSE', value: val };
}

export function hasQuickFiltersActive(filterType, activeFilterMap = {}) {
  return (
    Boolean(filterType && filterType !== 'all') ||
    Boolean(activeFilterMap.tags?.value?.length) ||
    Boolean(activeFilterMap.naics?.value?.length) ||
    Boolean(activeFilterMap.setAsides?.value?.length) ||
    Boolean(activeFilterMap.state?.value?.length)
  );
}
